import React from 'react'
import IssuedCheckProcessingLogProvider from './index.provider'
import IssuedCheckProcessingLogContent from './index.content'

const IssuedCheckProcessingLogScreen: React.FC = () => {
  return (
    <IssuedCheckProcessingLogProvider>
      <IssuedCheckProcessingLogContent />
    </IssuedCheckProcessingLogProvider>
  )
}

export default IssuedCheckProcessingLogScreen
